export default __webpack_public_path__ + "static/media/cien2.b0d04fc7.svg";